import React from 'react';
import { useStructuredSelector } from '~hooks';
import { isLoadedEmptySelector, slideshowSelector } from '~slices/teasers';
import { HorizonGalleryPlaceholder } from '~atoms';
import { Slider } from '~molecules';
var HorizonGalleryWithPlaceholder = function (_a) {
    var className = _a.className;
    var _b = useStructuredSelector({
        banners: slideshowSelector,
        isLoadedEmpty: isLoadedEmptySelector,
    }), banners = _b.banners, isLoadedEmpty = _b.isLoadedEmpty;
    var shouldDisplaySlider = Array.isArray(banners) && !!banners.length;
    if (!shouldDisplaySlider) {
        return (React.createElement(HorizonGalleryPlaceholder, { display: !isLoadedEmpty, className: className }));
    }
    return React.createElement(Slider, { position: "TOP", slideshows: banners, className: className });
};
export { HorizonGalleryWithPlaceholder };
